import React, { useRef, useState } from 'react'
import { Button, Card, Form, Input, InputRef, Typography, message } from 'antd'
import axios from 'axios'

interface LoginFormValues {
  email: string
  password: string
}

interface LoginResponse {
  ok: boolean
  redirect?: string
  errors?: string | { email?: string; password?: string }
}

export function Login() {
  const [form] = Form.useForm<LoginFormValues>()
  const [saving, setSaving] = useState(false)
  const passwordRef = useRef<InputRef>(null)

  const onFinish = async (values: LoginFormValues) => {
    setSaving(true)
    try {
      const { data } = await axios.post<LoginResponse>(
        '/login',
        { email: values.email || '', password: values.password || '' },
        {
          headers: { 'Content-Type': 'application/json' },
          validateStatus: status => status < 500,
        },
      )

      if (data.ok && data.redirect) {
        window.location.href = data.redirect
        return
      }

      if (typeof data.errors === 'string') {
        message.error(data.errors)
      }
    } catch (error) {
      console.error(error)
      message.error('Erreur lors de la connexion')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Card
        style={{ width: '100%', maxWidth: 400, boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.1)', borderRadius: 20 }}
        styles={{ body: { padding: 32 } }}
      >
        <Typography.Title level={3} style={{ textAlign: 'center' }}>
          Connectez-vous
        </Typography.Title>

        <Form form={form} layout="vertical" onFinish={onFinish} requiredMark>
          <Form.Item
            label="Email :"
            name="email"
            rules={[{ required: true, message: 'Ce champ est requis.' }]}
            className="no-box-shadow"
          >
            <Input
              type="email"
              autoFocus
              autoComplete="username"
              onPressEnter={e => {
                e.preventDefault()
                passwordRef.current?.focus()
              }}
            />
          </Form.Item>

          <Form.Item
            label="Mot de passe :"
            name="password"
            rules={[{ required: true, message: 'Ce champ est requis.' }]}
            className="no-box-shadow"
          >
            <Input.Password
              ref={passwordRef}
              autoComplete="current-password"
              onPressEnter={() => form.submit()}
            />
          </Form.Item>

          <Button type="primary" htmlType="submit" loading={saving} block>
            Connexion
          </Button>
        </Form>
      </Card>
    </div>
  )
}
